module.exports = __webpack_public_path__ + "img/图02-1.83f3a991.jpg";